export const getConfig = () => window.appConfig;
